import { render, staticRenderFns } from "./TopDefault.vue?vue&type=template&id=4bb997e4&scoped=true&lang=pug&"
import script from "./TopDefault.vue?vue&type=script&lang=ts&"
export * from "./TopDefault.vue?vue&type=script&lang=ts&"
import style0 from "./TopDefault.vue?vue&type=style&index=0&id=4bb997e4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb997e4",
  null
  
)

export default component.exports